import * as proto from 'src/proto/compiled-protos';
import { Observable, map, of } from "rxjs";
import { IndeterminatePaginatorData } from "src/app/general/components/indeterminate-paginator/indeterminate-paginator-model";
import { BackendService } from "../../services/backend.service";
import { DataTableColumn } from "src/app/general/components/data-table/data-table-column";
import { LocationsModel } from "./locations-model";

export class BusinessLocationsModel implements LocationsModel {
  businessId: string;
  backendService: BackendService;

  constructor(businessId: string, backendService: BackendService) {
    this.businessId = businessId;
    this.backendService = backendService;
  }

  fetchData(continuationToken: string | null | undefined): Observable<IndeterminatePaginatorData<proto.waiternow.common.ILocationProto>> {
    if (!this.businessId) {
      return of({data: new Array(), continuationToken: ''});
    }
    return this.backendService.findBusinessLocationsReturnObservable(this.businessId, continuationToken)
      .pipe(
        map(locations => {
          const paginatorData: IndeterminatePaginatorData<proto.waiternow.common.ILocationProto> = {data: [], continuationToken: continuationToken};
          if (locations) {
            paginatorData.data = locations.locations;
            paginatorData.continuationToken = locations.continuationToken;
          }
          return paginatorData;
        })
      );
  }

  getAdditionalColumns(): Array<DataTableColumn<proto.waiternow.common.ILocationProto>> {
    return new Array();
  }
}
